import React, { useEffect } from 'react';
import './consultorios.css';
import { consultorios_item } from '../../json/consultoriositem';




const Consultorio1 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container consul-container'>
            <div className='row'>
                <h3 className='title'>Consultorios Médicos</h3>
                <hr className='hr-gob' />
                <h6>La Oficialía Mayor pone a disposición de los trabajadores del Poder Ejecutivo del Estado de Hidalgo el servicio de consultorios médicos, con la finalidad
                    de prevenir enfermedades crónicas degenerativas e infecto contagiosas.
                </h6>
            </div>
            <br></br>
            <br></br>

            <div className='row'>
                {
                    consultorios_item.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='consul_item'>
                                <br></br>
                                <h5>{item.Ubicacion}</h5>
                                <h6>{item.telefono}</h6>
                                {
                                    item.especialidades.map((trim, index) => (
                                        <div key={index}>
                                            <div className='consultorios_icono'>
                                                <img src={"/assets/imgs/" + trim.icono} alt='' />
                                            </div>
                                            <br></br>
                                            <h6>{trim.nombre}</h6>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                       
                    ))
                }
            </div>








            <br></br>
            <br></br>

        {/*     <div className='row'>
                {
                    especialidades_item.map((trim, index) => (
                        <div key={index} className='consul_item col-md-3 col-sm-6 col-12'>
                            <div className='consultorios_icono'>
                                <img src={"/assets/imgs/" + trim.icono} />
                            </div>
                            <br></br>
                            <h6>{trim.nombre}</h6>
                        </div>
                    ))
                }
            </div > */}
        </div >
    )
}


export default Consultorio1